import React, { useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import { CBadge } from '@coreui/react'
import { decryptString } from '../services/crypto'
import './AppSidebarNav.css'

export const AppSidebarNav = ({ items, permissions, idFunc }) => {
  const [isMobile, setIsMobile] = useState(decryptString('isMobile'))
  const location = useLocation()

  const navLink = (name, icon, badge) => {
    return (
      <>
        {icon && icon}
        {name && name}
        {badge && (
          <CBadge color={badge.color} className="ms-auto">
            {badge.text}
          </CBadge>
        )}
      </>
    )
  }

  const navItem = (item, index) => {
    const { component, name, badge, icon, dscPage, perfis, ...rest } = item
    const Component = component
    const statusPermission = permissions[dscPage] === undefined ? 2 : permissions[dscPage].status

    if (isMobile && item.dscPage !== 'Cadastro cliente' && item.dscPage !== 'Dashboard')
      return false

    if ((perfis.includes(idFunc) || perfis.length === 0) && statusPermission !== 0) {
      return (
        <Component
          className="info-sidebar"
          {...(rest.to &&
            !rest.items && {
              component: NavLink,
            })}
          key={index}
          {...rest}
        >
          {navLink(name, icon, badge)}
        </Component>
      )
    }

    return false
  }
  const navGroup = (item, index) => {
    const { component, name, icon, to, dscPage, perfis, ...rest } = item
    const Component = component
    const permissionStatuses = item.items?.map((elem) => permissions[elem.dscPage]?.status) || []
    const statusPermission = permissionStatuses.every((valor) => valor === 0) ? 0 : 2

    if (isMobile && item.dscPage !== 'Clientes') return false

    if ((perfis.includes(idFunc) || perfis.length === 0) && statusPermission !== 0) {
      return (
        <Component
          className="info-sidebar"
          idx={String(index)}
          key={index}
          toggler={navLink(name, icon)}
          visible={location.pathname.startsWith(to)}
          {...rest}
        >
          {item.items?.map((item, index) =>
            item.items ? navGroup(item, index) : navItem(item, index),
          )}
        </Component>
      )
    }

    return false
  }

  return (
    <React.Fragment>
      {items.map((item, index) => (item.items ? navGroup(item, index) : navItem(item, index)))}
    </React.Fragment>
  )
}

AppSidebarNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
}
